<template>
<div class="padding20 bg-white margint20">
    <div class="flex-container paddingb20">
        <a :href="clickUrl"><p class="fs-11 text-light flex1" v-text="count +'人喜欢'" :data-scp="$options.name+'.00'"></p></a>
        <div class="badge badge-reverse badge-big badge-pill" @click.stop="likeThis" style="border-radius:500px;border-color: #e0e0e0;padding:0 12px;line-height: 22px;">
            <div class="flex-container">
                <i class="icon fs-14 float-left marginr10 text-dark" :class="isLike ? 'icon-discover_like animated bounceIn' : 'icon-counter_like'" :style="isLike ? 'color:#ff4c48;' : ''"></i>
                <span class="fs-12 text-dark">喜欢</span>
            </div>
        </div>
    </div>
    <a :href="clickUrl" :data-scp="$options.name+'.01'">
        <div class="box-row">
            <div class="img-container round float-left" v-for="item in imgList | limitBy bootPage" style="margin-right:.24rem">
                <img :src="item.imageUrl" style="width:0.75rem;height:0.75rem;">
            </div>
            <div class="img-container float-left" v-show="data.length>=bootPage">
                <img src="//image1.51tiangou.com/tgou2/img2/discover/ico-discover_imgMore.png" alt="" style="width:0.75rem;height:0.75rem;">
            </div>
        </div>
    </a>
</div>
</template>

<script>
import _ from '_';
import $ from 'jquery';
export default {
    props:{
        data: {
        	type: Array
            , default: []
        }
        , isLike:{  // 是否喜欢
            type: Boolean,
            default:false
        }
        , count: {
        	type: Number
            , default: 0
        }
        , bootPage: {
        	type: Number
            , default: 9
        }
        , clickUrl: {
        	type: String
            , default: ''
        }
    },
    data: function(){
    	return {
    		imgList: this.data.map((d)=>{
    			return {
    				img: d
                };
            })
        };
    },
    watch: {
    	data: function(newVal){
    		if( newVal ){
    			this.imgList = this.data.map((d)=>{
    				return {
    					imageUrl: d || '//image1.51tiangou.com/tgou2/img2/fitting/defaultPic.jpg'
                    };
                });
            }
        }
    },
    methods:{
        likeThis: function(){   // 向上抛出事件，点击该发现的喜欢按钮
            this.$dispatch('likeThis');
        }
    }
}
</script>

<style lang="scss">
.animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both
}
@-webkit-keyframes bounceIn {
    0%,100%,20%,40%,60%,80% {
        -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
        transition-timing-function: cubic-bezier(0.215,.61,.355,1)
    }

    0% {
        opacity: 0;
        -webkit-transform: scale3d(.1,.1,.1);
        transform: scale3d(.1,.1,.1)
    }

    20% {
        -webkit-transform: scale3d(1.3,1.3,1.3);
        transform: scale3d(1.3,1.3,1.3)
    }

    40% {
        -webkit-transform: scale3d(.9,.9,.9);
        transform: scale3d(.9,.9,.9)
    }

    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03,1.03,1.03);
        transform: scale3d(1.03,1.03,1.03)
    }

    80% {
        -webkit-transform: scale3d(.97,.97,.97);
        transform: scale3d(.97,.97,.97)
    }

    100% {
        opacity: 1;
        -webkit-transform: scale3d(1,1,1);
        transform: scale3d(1,1,1)
    }
}

@keyframes bounceIn {
    0%,100%,20%,40%,60%,80% {
        -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
        transition-timing-function: cubic-bezier(0.215,.61,.355,1)
    }

    0% {
        opacity: 0;
        -webkit-transform: scale3d(.1,.1,.1);
        -ms-transform: scale3d(.1,.1,.1);
        transform: scale3d(.1,.1,.1)
    }

    20% {
        -webkit-transform: scale3d(1.3,1.3,1.3);
        -ms-transform: scale3d(1.3,1.3,1.3);
        transform: scale3d(1.3,1.3,1.3)
    }

    40% {
        -webkit-transform: scale3d(.9,.9,.9);
        -ms-transform: scale3d(.9,.9,.9);
        transform: scale3d(.9,.9,.9)
    }

    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03,1.03,1.03);
        -ms-transform: scale3d(1.03,1.03,1.03);
        transform: scale3d(1.03,1.03,1.03)
    }

    80% {
        -webkit-transform: scale3d(.97,.97,.97);
        -ms-transform: scale3d(.97,.97,.97);
        transform: scale3d(.97,.97,.97)
    }

    100% {
        opacity: 1;
        -webkit-transform: scale3d(1,1,1);
        -ms-transform: scale3d(1,1,1);
        transform: scale3d(1,1,1)
    }
}

.bounceIn {
    -webkit-animation-name: bounceIn;
    animation-name: bounceIn;
    -webkit-animation-duration: .75s;
    animation-duration: .75s
}
</style>